import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import handleReceiveData from './actions/shared';

import LandingPage from './views/LandingPage/LandingPage';
import SignupPage from './views/SignupPage/SignupPage';
import LoginPage from './views/LoginPage/LoginPage';
import CategoriesPage from './views/CategoriesPage/CategoriesPage';
import NewGoalPage from './views/NewGoalPage/NewGoalPage';
import ComingSoonPage from './views/ComingSoonPage/ComingSoonPage';
import GoalDashboardPage from './views/GoalDashboardPage/GoalDashboardPage';
import GoalsListingPage from './views/GoalsListingPage/GoalListingPage';
import NavBar from './components/NavBar/NavBar';
import FourOFour from './views/404/FourOFour';
import LoadingBar from 'react-redux-loading';
import PrivacyPolicy from './views/Terms/PrivacyPolicy';
import TermsOfService from './views/Terms/TermsOfService';
require('dotenv').config();

class App extends Component {
  componentDidMount() {
    this.props.dispatch(handleReceiveData());
  }
  render() {
    const { authedUser } = this.props;
    return (
      <Fragment>
        {authedUser !== 'null' && <NavBar />}
        <LoadingBar />
        <Switch>
          <Route exact path='/' component={LandingPage} />
          <Route exact path='/signup' component={SignupPage} />
          <Route exact path='/login' component={LoginPage} />
          <Route exact path='/privacypolicy' component={PrivacyPolicy} />
          <Route exact path='/termsofservice' component={TermsOfService} />
          {authedUser !== 'null' && (
            <Switch>
              <Route exact path='/categories' component={CategoriesPage} />
              <Route exact path='/newgoal' component={NewGoalPage} />
              <Route exact path='/comingsoon' component={ComingSoonPage} />
              <Route exact path='/goals' component={GoalsListingPage} />
              <Route
                exact
                path='/goaldashboard/:param'
                component={GoalDashboardPage}
              />
              <Route component={FourOFour} />
            </Switch>
          )}

          <Route component={FourOFour} />
        </Switch>
      </Fragment>
    );
  }
}

function mapStateToProps({ authedUser }) {
  return { authedUser };
}

export default connect(mapStateToProps)(App);
